module.exports = __webpack_public_path__ + "static/media/usersGroupsBulkTemplate.98d5eec2.xlsx";